import React from 'react';
/* eslint-disable */
export function VariantPlus(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8.79981 11.3173V9.64516C8.54104 9.43141 8.30178 9.20525 8.08203 8.96667C7.92648 8.8 7.76814 8.63611 7.60703 8.475C7.44592 8.31389 7.25981 8.15556 7.0487 8C7.20425 7.87778 7.35147 7.75556 7.49036 7.63333C7.62925 7.51111 7.75981 7.38333 7.88203 7.25L6.93203 6.3C6.64314 6.61111 6.3487 6.86111 6.0487 7.05C5.7487 7.23889 5.28759 7.33333 4.66536 7.33333H1.33203L1.33203 8.66667L4.66536 8.66667C5.34314 8.66667 5.83481 8.77778 6.14036 9C6.44592 9.22222 6.75981 9.51111 7.08203 9.86667C7.50425 10.3333 8.05147 10.8 8.7237 11.2667C8.74845 11.2838 8.77382 11.3007 8.79981 11.3173Z"
        fill="currentColor"
      />
      <path
        d="M11.282 4.04167C11.0154 4.05833 10.7709 4.08889 10.5487 4.13333L10.8654 5.43333C11.0431 5.41111 11.2348 5.38889 11.4404 5.36667C11.6459 5.34445 11.8654 5.33333 12.0987 5.33333L11.0654 6.38333L11.9987 7.33333L14.6654 4.66667L11.9987 2L11.0654 2.93333L12.1154 4C11.8265 4.01111 11.5487 4.025 11.282 4.04167Z"
        fill="currentColor"
      />
      <path
        d="M8.43203 4.925C8.12092 5.13056 7.8487 5.34444 7.61536 5.56667L8.56536 6.51667C8.73203 6.35 8.92092 6.19445 9.13203 6.05C9.34314 5.90556 9.5987 5.77778 9.8987 5.66667L9.58203 4.38333C9.12648 4.53889 8.74314 4.71944 8.43203 4.925Z"
        fill="currentColor"
      />
      <path
        d="M11.7998 13.6V11.8H9.99981V10.6H11.7998V8.80002H12.9998V10.6H14.7998V11.8H12.9998V13.6H11.7998Z"
        fill="currentColor"
      />
    </svg>
  );
}
